module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/17Kh7j11siaAgGOgawmIeu-0dbe1e6e0add9660b0be299926d12a5c.jpg";